<template>
<transition name="modal">
<div id="modal" class="modal">
  <div class="modal__wrap">
    <div class="modal__wrap__card">
      <header class="modal__wrap__card__header">
         この商品は編集できません
      </header>
      <div class="modal__wrap__card__content">
        <p>別の端末で編集中、またはすでに購入された商品です。</p>
      </div>
      <div class="modal__wrap__card__navi">
        <router-link
        :to="routerLink[target]"
        class="modal__wrap__card__navi__btn">HOMEへ戻る</router-link>
      </div>
    </div>
  </div>
  <div class="modal__background"></div>
</div>
</transition>
</template>
<script>
export default {
  props: {
    target: String
  },
  data () {
    return {
      routerLink: {
        'mirror': {name: 'mirror-home'},
        'sp': {name: 'home'}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LockModal.vue